import { render, staticRenderFns } from "./RefsTableLens.vue?vue&type=template&id=345f9e4d&scoped=true&"
import script from "./RefsTableLens.vue?vue&type=script&lang=js&"
export * from "./RefsTableLens.vue?vue&type=script&lang=js&"
import style0 from "./RefsTableLens.vue?vue&type=style&index=0&id=345f9e4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f9e4d",
  null
  
)

export default component.exports